import axios, { InternalAxiosRequestConfig } from "axios";
import config from "../config";
import { AjaxInstance, AjaxRequestConfig, IdValueQuery } from "./types";
import { fetchAuthSession } from "aws-amplify/auth";

const ajax: AjaxInstance = axios.create();

const init = () => {
  ajax.defaults.baseURL = config.configEndpoints.baseEndpoint;
  ajax.defaults.headers.post["Content-Type"] = "application/json";
  ajax.defaults.headers.put["Content-Type"] = "application/json";
  ajax.interceptors.request.use(requestIntercept, (error) => Promise.reject(error));
  return ajax;
};

const requestIntercept = async (request: AjaxRequestConfig): Promise<InternalAxiosRequestConfig> => {
  if (!request?.skip_bearer_injection && request.headers) {
    const session = await fetchAuthSession();
    if (session) {
      request.headers.Authorization = `Bearer ${session?.tokens?.idToken?.toString()}`;
    }
  }

  if (request.is_hub) {
    request.baseURL = request.baseURL?.replace("/partner", "");
  }

  if (request.serialize) {
    request.paramsSerializer = function(params) {
      const parsed = new URLSearchParams();
      for (let key of Object.keys(params)) {
        if (key === "queries") {
          params.queries.forEach((q: IdValueQuery) => parsed.append(q.id, q.value));
        } else if (params[key] !== undefined) {
          const isArray = Array.isArray(params[key]);
          parsed.append(key, isArray ? params[key].toString() : params[key]);
        }
      }
      return parsed.toString();
    };
  }
  return request as InternalAxiosRequestConfig;
};

export default init();
